import {ChangeDetectorRef, Component, Input, OnInit, ViewChild} from "@angular/core";
import {AbstractListView} from "../../../core/visbos-core/ui/components/abstract-list-view";
import {DatatableComponent} from "../../../core/visbos-core/ui/components/datatable/datatable.component";
import {SessionActions} from "../../../shared/actions/session.actions";
import {Medicine} from "../../model/medicine.type";
import {ApolloQueryObservable} from "apollo-angular";
import {MedicineService} from "../../services/medicine.service";
import {ActivatedRoute, Router} from "@angular/router";
import {GenericModalComponent} from "../../../core/visbos-core/ui/forms/generic-modal/generic-modal.component";
import {MedicineFormComponent} from "../medicine-form/medicine-form.component";
import {MessageType} from "../../../shared/redux-store/session/session.types";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";

@Component({
  selector: 'vb-medicine-list',
  templateUrl: './medicine-list.component.html',
  styleUrls: ['./medicine-list.component.css']
})
export class MedicineListComponent extends AbstractListView implements OnInit {

  @ViewChild('medicinesTable')
  table: DatatableComponent;

  @Input()
  showMedicineBookButton: boolean = true;

  @ViewChild('editMedicineModal')
  editMedicineModal: GenericModalComponent;

  @ViewChild('editMedicineForm')
  editMedicineForm: MedicineFormComponent;

  messages = {
    emptyMessage: 'Keine Medikamente auf der Liste',
    totalMessage: 'Medikamente'
  };

  currentItem: Medicine;

  private medicineList$: ApolloQueryObservable<any>;
  medicineList: Medicine[];

  constructor(sessionActions: SessionActions,
              private medService: MedicineService,
              private router: Router, private route: ActivatedRoute,
              cd: ChangeDetectorRef) {

    super(sessionActions, cd);

  }

  ngOnInit() {

    this.isLoading = true;

    this.medicineList$ = this.medService.getMedicines(this.activeAdminUnitCuid$);
    this.addComponentData(this.medicineList$);

    this.dataSubscriptions.push(
      this.medicineList$.subscribe(res => {
        this.medicineList = res.data.medicines;
        this.isLoading = res.loading;
        this.rows = this.medicineList;
      })
    );

    this.dataSubscriptions.push(
      this.searchTerm.valueChanges.pipe(
        distinctUntilChanged(),
        debounceTime(500)
      ).subscribe((term: any) => this.filterItems(term))
    );

    this.columns = [
      {prop: 'administration_unit.label', name: 'Verwaltungseinheit', minWidth: 100, flexGrow: 2},
      {prop: 'name', name: 'Handelsname', minWidth: 100, flexGrow: 2},
      {prop: 'substances.0.substance.name', name: 'Wirkstoff', minWidth: 100, flexGrow: 2},
      {prop: 'dosage_per_capacity_string', name: 'Dosierung', minWidth: 50, flexGrow: 1, sortable: false},
      {prop: 'notes', name: 'Bemerkungen', flexGrow: 2, sortable: true},
    ];

  }

  filterItems(searchTerm) {
    if (!searchTerm || searchTerm == "") {
      this.rows = this.medicineList;
    } else {
      if (this.medicineList) {
        this.rows = this.medicineList.filter((si: any) => this.findStringInTable(si, this.columns, searchTerm));
      }
    }
  }

  onCellUpdate(row, res, index) {

  }

  showMedicineBookClicked(cuid: string) {
    this.router.navigate(['verbrauch', cuid], {relativeTo: this.route});
  }

  onAddMedicineClicked() {
    this.currentItem = null;
    this.cd.detectChanges();
    this.editMedicineForm.reset();
    this.editMedicineModal.show();
    this.cd.detectChanges();
  }

  onEditMedicineClicked(medicineCuid: string) {
    this.currentItem = this.medicineList.find(med => med.cuid === medicineCuid);
    this.cd.detectChanges();
    this.editMedicineForm.reset();
    this.editMedicineModal.show();
    this.cd.detectChanges();
  }

  onDeleteMedicineClicked(medicineCuid: string) {
    this.medService.deleteMedicine(medicineCuid).subscribe(res => {
      this.sessionActions.pushMessage("Medikament erfolgreich gelöscht!", MessageType.SUCCESS, "Medikamentenliste");
    }, err => {
      this.sessionActions.throwError(err, "Fehler beim Löschen des Medikaments!");
    });
  }

  createMedicine() {
    this.editMedicineForm.createNewMedicine().subscribe(res => {
        this.sessionActions.pushMessage("Medikament erfolgreich hinzugefügt!", MessageType.SUCCESS, "Medikamentenliste");
      },
      err => {
        this.sessionActions.throwError(err, "Fehler beim manuellen Anlegen des Medikaments!");
      });
  }

  updateMedicine() {
    this.editMedicineForm.updateMedicine().subscribe(res => {

    }, err => {
      this.sessionActions.throwError(err, "Fehler beim Ändern des Medikaments!");
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/medicine/medicine-list/medicine-list.component.ts